// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.player-diagnostics {
  display: flex;
  flex-direction: column;
  gap: 16px;
  font-size: 13px;
  line-height: 1.45;
}
.player-diagnostics__section {
  border: 1px solid rgba(128, 128, 128, 0.22);
  border-radius: 8px;
  padding: 14px 16px;
}
.player-diagnostics__title {
  margin: 0 0 10px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  opacity: 0.7;
}
.player-diagnostics__wizard-intro p {
  margin: 0 0 12px;
  opacity: 0.8;
}
.player-diagnostics__steps {
  list-style: none;
  margin: 0;
  padding: 0;
}
.player-diagnostics__step {
  display: flex;
  gap: 10px;
  padding: 8px 0;
}
.player-diagnostics__step + .player-diagnostics__step {
  border-top: 1px solid rgba(128, 128, 128, 0.14);
}
.player-diagnostics__step-marker {
  flex: 0 0 auto;
  width: 10px;
  height: 10px;
  margin-top: 5px;
  border-radius: 50%;
  background: rgba(128, 128, 128, 0.35);
}
.player-diagnostics__step-body {
  flex: 1;
  min-width: 0;
}
.player-diagnostics__step-title {
  display: block;
  font-weight: 600;
}
.player-diagnostics__step-counter {
  display: inline-block;
  margin-top: 2px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  opacity: 0.6;
}
.player-diagnostics__step-instruction, .player-diagnostics__step-detail {
  margin: 4px 0 0;
}
.player-diagnostics__step-detail {
  font-size: 12px;
  opacity: 0.75;
}
.player-diagnostics__confirm {
  margin-top: 8px;
  padding: 10px;
  border: 1px solid rgba(57, 135, 229, 0.45);
  border-radius: 6px;
  background: rgba(57, 135, 229, 0.08);
}
.player-diagnostics__confirm-detail {
  margin: 0;
  font-size: 12px;
  opacity: 0.75;
}
.player-diagnostics__confirm-question {
  margin: 4px 0 8px;
  font-size: 13px;
  font-weight: 600;
}
.player-diagnostics__confirm-note {
  margin-bottom: 8px;
}
.player-diagnostics__confirm-actions {
  display: flex;
  gap: 8px;
}
.player-diagnostics__step-answer {
  margin: 4px 0 0;
  font-size: 12px;
  opacity: 0.8;
}
.player-diagnostics__interactive-note {
  margin: 0 0 12px;
  padding: 6px 10px;
  border-radius: 6px;
  border: 1px dashed rgba(57, 135, 229, 0.5);
  font-size: 11px;
  line-height: 1.4;
}
.player-diagnostics__step-actions {
  display: flex;
  gap: 8px;
  margin-top: 8px;
}
.player-diagnostics__step-shot {
  display: block;
  width: 100%;
  margin-top: 8px;
  border: 1px solid rgba(128, 128, 128, 0.25);
  border-radius: 6px;
  aspect-ratio: 16/9;
  object-fit: cover;
}
.player-diagnostics__step-shot--placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 14px;
  border-style: dashed;
  background: rgba(128, 128, 128, 0.06);
  font-size: 11px;
  line-height: 1.4;
  text-align: center;
  opacity: 0.65;
}
.player-diagnostics__step-note {
  margin: 6px 0 0;
  font-size: 11px;
  font-style: italic;
  opacity: 0.6;
}
.player-diagnostics__note {
  margin: 12px 0 0;
  font-size: 11px;
  line-height: 1.5;
  opacity: 0.6;
}
.player-diagnostics__measuring {
  margin-top: 8px;
  padding: 8px 10px;
  border: 1px solid rgba(57, 135, 229, 0.45);
  border-radius: 6px;
  background: rgba(57, 135, 229, 0.1);
}
.player-diagnostics__measuring-head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;
}
.player-diagnostics__measuring-label {
  font-size: 12px;
  font-weight: 600;
  color: #2f6fbf;
}
.player-diagnostics__measuring-clock {
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 15px;
  font-weight: 600;
  color: #2f6fbf;
  font-variant-numeric: tabular-nums;
}
.player-diagnostics__measuring-track {
  margin-top: 6px;
  height: 6px;
  border-radius: 3px;
  background: rgba(57, 135, 229, 0.2);
  overflow: hidden;
}
.player-diagnostics__measuring-fill {
  height: 100%;
  border-radius: 3px;
  background: #3987e5;
  transition: width 0.9s linear;
}
.player-diagnostics__step-actions {
  display: flex;
  gap: 8px;
  margin-top: 8px;
}
.player-diagnostics__step--waiting {
  opacity: 0.45;
}
.player-diagnostics__step--active .player-diagnostics__step-marker {
  background: #3987e5;
  animation: player-diagnostics-pulse 1.4s ease-in-out infinite;
}
.player-diagnostics__step--done .player-diagnostics__step-marker {
  background: #199e70;
}
.player-diagnostics__step--warn .player-diagnostics__step-marker {
  background: #d9822b;
}
.player-diagnostics__step--missed .player-diagnostics__step-marker, .player-diagnostics__step--failed .player-diagnostics__step-marker {
  background: #d95926;
}
.player-diagnostics__step--unavailable {
  opacity: 0.55;
}
.player-diagnostics__result {
  margin-top: 16px;
  padding: 14px;
  border: 1px solid;
  border-radius: 8px;
}
.player-diagnostics__result p {
  margin: 0;
}
.player-diagnostics__result--pass {
  border-color: rgba(25, 158, 112, 0.45);
  background: rgba(25, 158, 112, 0.1);
}
.player-diagnostics__result--warn {
  border-color: rgba(217, 130, 43, 0.45);
  background: rgba(217, 130, 43, 0.1);
}
.player-diagnostics__result--fail {
  border-color: rgba(217, 89, 38, 0.45);
  background: rgba(217, 89, 38, 0.1);
}
.player-diagnostics__result-head {
  display: flex;
  align-items: center;
  gap: 12px;
}
.player-diagnostics__result-icon {
  flex: 0 0 auto;
  width: 28px;
  height: 28px;
}
.player-diagnostics__result-heading {
  min-width: 0;
}
.player-diagnostics__result-eyebrow {
  display: block;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  opacity: 0.6;
}
.player-diagnostics__result-stats {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  list-style: none;
  margin: 12px 0;
  padding: 0;
}
.player-diagnostics__result-stat {
  padding: 2px 8px;
  border-radius: 999px;
  background: rgba(128, 128, 128, 0.16);
  font-size: 11px;
  font-weight: 600;
}
.player-diagnostics__result-stat--ok {
  background: rgba(25, 158, 112, 0.2);
  color: #0f6b4c;
}
.player-diagnostics__result-stat--warn {
  background: rgba(217, 130, 43, 0.2);
  color: #94591b;
}
.player-diagnostics__result-stat--fail {
  background: rgba(217, 89, 38, 0.2);
  color: #933a18;
}
.player-diagnostics__simulated {
  margin: 0 0 12px;
  padding: 6px 10px;
  border-radius: 6px;
  border: 1px dashed #d9822b;
  color: #d9822b;
  font-size: 11px;
  line-height: 1.4;
}
.player-diagnostics__wizard-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.player-diagnostics__report-block {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid rgba(128, 128, 128, 0.14);
}
.player-diagnostics__report-intro {
  margin: 0 0 6px;
  font-size: 12px;
  line-height: 1.45;
}
.player-diagnostics__report-intro strong {
  font-weight: 600;
}
.player-diagnostics__report-steps {
  margin: 0 0 10px;
  padding-left: 18px;
  font-size: 12px;
  line-height: 1.5;
  opacity: 0.85;
}
.player-diagnostics__report-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.player-diagnostics__report {
  margin-top: 10px;
}
.player-diagnostics__report p {
  margin: 0 0 6px;
  font-size: 11px;
  opacity: 0.7;
}
.player-diagnostics__report-text {
  width: 100%;
  padding: 8px;
  border: 1px solid rgba(128, 128, 128, 0.3);
  border-radius: 6px;
  background: rgba(128, 128, 128, 0.06);
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 11px;
  line-height: 1.45;
  resize: vertical;
}
.player-diagnostics__verdict {
  font-size: 16px;
  font-weight: 700;
  line-height: 1.25;
}
.player-diagnostics__metrics {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px 12px;
  margin: 0;
}
.player-diagnostics__metric {
  min-width: 0;
}
.player-diagnostics__metric dt {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  opacity: 0.6;
}
.player-diagnostics__metric dd {
  margin: 0;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 13px;
  overflow-wrap: anywhere;
}
.player-diagnostics__checklist {
  list-style: none;
  margin: 0;
  padding: 0;
}
.player-diagnostics__check {
  position: relative;
  padding: 4px 0 4px 20px;
}
.player-diagnostics__check::before {
  position: absolute;
  left: 0;
  font-weight: 700;
}
.player-diagnostics__check--ok::before {
  content: "✓";
  color: #199e70;
}
.player-diagnostics__check--warn::before {
  content: "⚠";
  color: #d9822b;
}
.player-diagnostics__check--fail::before {
  content: "✗";
  color: #d95926;
}
.player-diagnostics__check--info::before {
  content: "•";
  opacity: 0.55;
}

@keyframes player-diagnostics-pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.3;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/blocks/PlayerDiagnostics/PlayerDiagnostics.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAEhB;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,eAAA;EACA,iBAAA;AAAJ;AAEI;EACI,2CAAA;EACA,kBAAA;EACA,kBAAA;AAAR;AAGI;EACI,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,YAAA;AADR;AAMI;EACI,gBAAA;EACA,YAAA;AAJR;AAOI;EACI,gBAAA;EACA,SAAA;EACA,UAAA;AALR;AAQI;EACI,aAAA;EACA,SAAA;EACA,cAAA;AANR;AAQQ;EACI,+CAAA;AANZ;AAUI;EACI,cAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,qCAAA;AARR;AAWI;EACI,OAAA;EACA,YAAA;AATR;AAYI;EACI,cAAA;EACA,gBAAA;AAVR;AAaI;EACI,qBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,YAAA;AAXR;AAcI;EAEI,eAAA;AAbR;AAgBI;EACI,eAAA;EACA,aAAA;AAdR;AAmBI;EACI,eAAA;EACA,aAAA;EACA,0CAAA;EACA,kBAAA;EACA,oCAAA;AAjBR;AAoBI;EACI,SAAA;EACA,eAAA;EACA,aAAA;AAlBR;AAqBI;EACI,iBAAA;EACA,eAAA;EACA,gBAAA;AAnBR;AAsBI;EACI,kBAAA;AApBR;AAuBI;EACI,aAAA;EACA,QAAA;AArBR;AAwBI;EACI,eAAA;EACA,eAAA;EACA,YAAA;AAtBR;AAyBI;EACI,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,0CAAA;EACA,eAAA;EACA,gBAAA;AAvBR;AA0BI;EACI,aAAA;EACA,QAAA;EACA,eAAA;AAxBR;AA8BI;EACI,cAAA;EACA,WAAA;EACA,eAAA;EACA,2CAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;AA5BR;AA+BI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,oBAAA;EACA,qCAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;AA7BR;AAgCI;EACI,eAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;AA9BR;AAiCI;EACI,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;AA/BR;AAqCI;EACI,eAAA;EACA,iBAAA;EACA,0CAAA;EACA,kBAAA;EACA,mCAAA;AAnCR;AAsCI;EACI,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,QAAA;AApCR;AAuCI;EACI,eAAA;EACA,gBAAA;EACA,cAAA;AArCR;AAwCI;EACI,2DAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kCAAA;AAtCR;AAyCI;EACI,eAAA;EACA,WAAA;EACA,kBAAA;EACA,mCAAA;EACA,gBAAA;AAvCR;AA0CI;EACI,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,6BAAA;AAxCR;AA2CI;EACI,aAAA;EACA,QAAA;EACA,eAAA;AAzCR;AA4CI;EACI,aAAA;AA1CR;AA6CI;EACI,mBAAA;EACA,6DAAA;AA3CR;AA8CI;EACI,mBAAA;AA5CR;AA+CI;EACI,mBAAA;AA7CR;AAgDI;EAEI,mBAAA;AA/CR;AAkDI;EACI,aAAA;AAhDR;AAqDI;EACI,gBAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;AAnDR;AAqDQ;EACI,SAAA;AAnDZ;AAuDI;EACI,sCAAA;EACA,mCAAA;AArDR;AAwDI;EACI,sCAAA;EACA,mCAAA;AAtDR;AAyDI;EACI,qCAAA;EACA,kCAAA;AAvDR;AA0DI;EACI,aAAA;EACA,mBAAA;EACA,SAAA;AAxDR;AA2DI;EACI,cAAA;EACA,WAAA;EACA,YAAA;AAzDR;AA4DI;EACI,YAAA;AA1DR;AA6DI;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,YAAA;AA3DR;AA8DI;EACI,aAAA;EACA,eAAA;EACA,QAAA;EACA,gBAAA;EACA,cAAA;EACA,UAAA;AA5DR;AA+DI;EACI,gBAAA;EACA,oBAAA;EACA,qCAAA;EACA,eAAA;EACA,gBAAA;AA7DR;AAgEI;EACI,mCAAA;EACA,cAAA;AA9DR;AAiEI;EACI,mCAAA;EACA,cAAA;AA/DR;AAkEI;EACI,kCAAA;EACA,cAAA;AAhER;AAmEI;EACI,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,0BAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAjER;AAoEI;EACI,aAAA;EACA,eAAA;EACA,QAAA;AAlER;AAqEI;EACI,gBAAA;EACA,iBAAA;EACA,+CAAA;AAnER;AAsEI;EACI,eAAA;EACA,eAAA;EACA,iBAAA;AApER;AAsEQ;EACI,gBAAA;AApEZ;AAwEI;EACI,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;AAtER;AAyEI;EACI,aAAA;EACA,eAAA;EACA,QAAA;AAvER;AA0EI;EACI,gBAAA;AAxER;AA0EQ;EACI,eAAA;EACA,eAAA;EACA,YAAA;AAxEZ;AA4EI;EACI,WAAA;EACA,YAAA;EACA,0CAAA;EACA,kBAAA;EACA,qCAAA;EACA,2DAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AA1ER;AA6EI;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;AA3ER;AAgFI;EACI,aAAA;EACA,gDAAA;EACA,aAAA;EACA,SAAA;AA9ER;AAiFI;EACI,YAAA;AA/ER;AAiFQ;EACI,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,YAAA;AA/EZ;AAkFQ;EACI,SAAA;EACA,2DAAA;EACA,eAAA;EACA,uBAAA;AAhFZ;AAsFI;EACI,gBAAA;EACA,SAAA;EACA,UAAA;AApFR;AAuFI;EACI,kBAAA;EACA,uBAAA;AArFR;AAuFQ;EACI,kBAAA;EACA,OAAA;EACA,gBAAA;AArFZ;AAyFI;EACI,YAAA;EACA,cAAA;AAvFR;AA0FI;EACI,YAAA;EACA,cAAA;AAxFR;AA2FI;EACI,YAAA;EACA,cAAA;AAzFR;AA4FI;EACI,YAAA;EACA,aAAA;AA1FR;;AA8FA;EACI;IAEI,UAAA;EA5FN;EA8FE;IACI,YAAA;EA5FN;AACF","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
